function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCalendarRexOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M5 27h22V16h2v11a2 2 0 01-2 2H5a2 2 0 01-2-2V16h2v11zm7-3H8v-2h4v2zm6 0h-4v-2h4v2zm6 0h-4v-2h4v2zm-12-4H8v-2h4v2zm6 0h-4v-2h4v2zm6 0h-4v-2h4v2zM10 5h12V3h2v2h3a2 2 0 012 2v7H3V7a2 2 0 012-2h3V3h2v2zm-5 7h22V7h-3v3h-2V7H10v3H8V7H5v5z",
    fill: props.color
  }));
}

export default SvgIconCalendarRexOutline;